import "antd/es/config-provider/style";
import _ConfigProvider from "antd/es/config-provider";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import DatePickerTable from "./components/DatePickerTable";
import DatePickerTitle from "./components/DatePickerTitle";
import { DEFAULT_MAX_RANGE, DEFAULT_MIN_RANGE, DEFAULT_SUBTRACT_MONTH_NUMBER, DEFAULT_TABLE_HEIGHT, DEFAULT_TOTAL_MONTH_NUMBER } from "./constant";
import { generateMonthDateForMonthly, onCustomMonthScroll } from "./util";
import dayjs from 'dayjs';
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { ScrollSync } from 'react-virtualized';
import 'react-virtualized/styles.css';
import "./style.less";
var DatePicker = /*#__PURE__*/forwardRef(function (props, ref) {
  var totalMonthNumber = props.totalMonthNumber || DEFAULT_TOTAL_MONTH_NUMBER;
  var subtractMonthNumber = props.subtractMonthNumber || DEFAULT_SUBTRACT_MONTH_NUMBER;
  var minRange = props.minRange || DEFAULT_MIN_RANGE;
  var maxRange = props.maxRange || DEFAULT_MAX_RANGE;
  var tableHeight = props.tableHeight || DEFAULT_TABLE_HEIGHT;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    monthDateForMonthly = _useState2[0],
    setMonthDateForMonthly = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    customScrollTop = _useState4[0],
    setCustomScrollTop = _useState4[1];
  var todayScrollTop = useRef(0);
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    monthTitle = _useState6[0],
    setMonthTitle = _useState6[1];
  var tableRef = useRef(null);
  var _useState7 = useState(dayjs()),
    _useState8 = _slicedToArray(_useState7, 2),
    monthlyTitleSelectedDate = _useState8[0],
    setMonthlyTitleSelectedDate = _useState8[1];
  useEffect(function () {
    var date = generateMonthDateForMonthly(totalMonthNumber, subtractMonthNumber);
    setMonthDateForMonthly(date);
  }, []);

  // @ts-ignore
  useImperativeHandle(ref, function () {
    return {
      forceClearSelect: function forceClearSelect() {
        if (tableRef.current) {
          // @ts-ignore
          tableRef.current.forceClearSelect();
        }
      }
    };
  });
  return /*#__PURE__*/React.createElement(_ConfigProvider, {
    theme: {
      token: {
        colorPrimary: '#1d1d1f'
      }
    }
  }, /*#__PURE__*/React.createElement(ScrollSync, null, function (_ref) {
    var clientHeight = _ref.clientHeight,
      clientWidth = _ref.clientWidth,
      _onScroll = _ref.onScroll,
      scrollHeight = _ref.scrollHeight,
      scrollWidth = _ref.scrollWidth,
      scrollLeft = _ref.scrollLeft;
    return /*#__PURE__*/React.createElement("div", {
      ref: ref,
      className: "date-picker-container"
    }, /*#__PURE__*/React.createElement(DatePickerTitle, {
      monthTitle: monthTitle,
      monthDate: monthDateForMonthly,
      setCustomScrollTop: setCustomScrollTop,
      todayScrollTop: todayScrollTop,
      cellHeightMonthly: scrollWidth / 7,
      monthlyTitleSelectedDate: monthlyTitleSelectedDate,
      setMonthlyTitleSelectedDate: setMonthlyTitleSelectedDate
    }), /*#__PURE__*/React.createElement(DatePickerTable, {
      value: props.value,
      minRange: minRange,
      maxRange: maxRange,
      todayScrollTop: todayScrollTop,
      cellHeightMonthly: props.cellHeightMonthly,
      ref: tableRef,
      monthDate: monthDateForMonthly,
      tableHeight: tableHeight,
      blockCells: props.blockCells,
      checkoutOnlyCells: props.checkoutOnlyCells,
      unavailableDueToMinimumStayCells: props.unavailableDueToMinimumStayCells,
      onSelect: props.onSelect,
      monthTitle: monthTitle,
      setMonthTitle: setMonthTitle,
      clientHeight: clientHeight,
      clientWidth: clientWidth,
      setMonthlyTitleSelectedDate: setMonthlyTitleSelectedDate,
      onScroll: function onScroll(sp) {
        onCustomMonthScroll(sp, setCustomScrollTop, _onScroll);
      },
      setCustomScrollTop: setCustomScrollTop,
      customScrollTop: customScrollTop,
      scrollHeight: scrollHeight,
      scrollLeft: scrollLeft,
      scrollTop: customScrollTop,
      scrollWidth: scrollWidth
    }));
  }));
});
export default DatePicker;